import React from "react";
import { TableHeaders } from "../../plugins/table";
import { Result } from "../../modal/result";
import { useAppDispatch } from "../../modal/hooks";
import { useNavigate } from "react-router-dom";
import { Locations } from "../../constants/locations";
import { resetHeaderName } from "../../services/result-detail/result-detail.slice";
import { CrownIcon, ReScheduleIcon } from "../../assets/svg";
import { Tooltip } from "antd";
import "./filter.scss";

export const columns = (
	onClicked: (id: number) => void,
	handleSelect: (id: number, event: any) => void,
	handleReschedule: (row: any) => void,
	selectStudent: any
): TableHeaders[] => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const handleNavigateToStudentResults = (id: number, name: string) => {
		dispatch(resetHeaderName(name));
		navigate(Locations.RESULT_DETAILS, {
			state: {
				sID: id,
				name: name,
			},
		});
	};

	return [
		{
			id: "selected",
			headerText: "-",
			sortable: false,
			resizable: true,
			rowElement: (row: Result, index: number) => {
				return (
					<div className="custom_secondary_form">
						{!row.completed ? (
							"-"
						) : (
							<input
								className="custom_checkbox mt-1"
								type="checkbox"
								checked={selectStudent[index]?.status}
								onChange={() => handleSelect(row.id, event)}
							/>
						)}
						{/* {!row.completed ? (
						<span className="incomplete">Not Completed</span>
					) : (
						<StatusDropDown
							value={row.selected}
							handleChange={(e: string) => {
								dispatch(
									actionChange({
										id: row.id,
										payload: {
											selected: e,
										},
									})
								);
							}}
							disabled={!row.completed}
						/>
					)} */}
					</div>
				);
			},
			maxWidth: 80,
			minWidth: 80,
			defaultWidth: 80,
		},
		{
			id: "slno",
			headerText: "Sl.No",
			sortable: false,
			resizable: true,
			rowElement: (_row: Result, index: number) => <div className="active">{index + 1}</div>,
			maxWidth: 80,
			minWidth: 80,
			defaultWidth: 80,
		},
		{
			id: "status",
			headerText: "Status",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="d-flex align-items-center justify-content-center">
					<Tooltip title={!row.completed ? `Exam failed due to ${row.failedReason}` : ""} placement="top">
						<span className={`${row.completed ? "success-chip result_chip" : "failed-chip"}`}>
							{row.completed ? <div>Completed</div> : "Not completed"}
						</span>
					</Tooltip>
					{!row.completed ? (
						<Tooltip title="Reschedule" placement="top">
							<span
								className="ml-1 cursor_pointer icon_btn"
								onClick={() => handleReschedule(row)}
							>
								<ReScheduleIcon width={20} height={20} />
							</span>
						</Tooltip>
					) : (
						""
					)}
				</div>
			),
			maxWidth: 180,
			minWidth: 180,
			defaultWidth: 180,
		},
		{
			id: "year",
			headerText: "Year",
			sortable: true,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.year}
				</div>
			),
			maxWidth: 200,
			minWidth: 150,
			defaultWidth: 180,
		},
		{
			id: "score",
			headerText: "Score",
			sortable: true,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.score}
				</div>
			),
			maxWidth: 180,
			minWidth: 180,
			defaultWidth: 180,
		},
		{
			id: "name",
			headerText: "Name",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="link link_color" onClick={() => handleNavigateToStudentResults(row.id, row.name)}>
					<span className="cursor_pointer">{row.name}</span>
					{row.selected === "SELECTED" && (
						<Tooltip title="Selected" placement="top">
							<span className="pl-2">
								<CrownIcon />
							</span>
						</Tooltip>
					)}
				</div>
			),
			maxWidth: 220,
			minWidth: 220,
			defaultWidth: 220,
		},
		{
			id: "collegeName",
			headerText: "College",
			sortable: true,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.collegeName}
				</div>
			),
			maxWidth: 280,
			minWidth: 280,
			defaultWidth: 280,
		},
		// {
		// 	id: "collegeId",
		// 	headerText: "College ID",
		// 	sortable: false,
		// 	resizable: true,
		// 	rowElement: (row: Result) => <div className="active" onClick={ () =>onClicked(row.id)}>{row.collegeId}</div>,
		// 	maxWidth: 200,
		// 	minWidth: 200,
		// 	defaultWidth: 200,

		// },
		{
			id: "department",
			headerText: "Department",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.department}
				</div>
			),
			maxWidth: 250,
			minWidth: 250,
			defaultWidth: 250,
		},
		{
			id: "cgpa",
			headerText: "CGPA",
			sortable: true,
			resizable: true,
			rowElement: (row: Result) => <div className="active">{row.cgpa}</div>,
			maxWidth: 120,
			minWidth: 120,
			defaultWidth: 120,
		},
		{
			id: "backpapers",
			headerText: "No of Backlogs",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.backPapers}
				</div>
			),
			maxWidth: 160,
			minWidth: 160,
			defaultWidth: 160,
		},
		{
			id: "email",
			headerText: "Email ID",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.email}
				</div>
			),
			maxWidth: 250,
			minWidth: 250,
			defaultWidth: 250,
		},
		{
			id: "contactNo",
			headerText: "Contact Number",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.contactNo}
				</div>
			),
			maxWidth: 160,
			minWidth: 160,
			defaultWidth: 160,
		},
		{
			id: "place",
			headerText: "Place",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.place}
				</div>
			),
			maxWidth: 200,
			minWidth: 200,
			defaultWidth: 200,
		},
		{
			id: "gender",
			headerText: "Gender",
			sortable: false,
			resizable: true,
			rowElement: (row: Result) => (
				<div className="active" onClick={() => onClicked(row.id)}>
					{row.gender}
				</div>
			),
			maxWidth: 140,
			minWidth: 140,
			defaultWidth: 140,
		},
	];
};
